import {ShopPageTitle} from "../shop/_components/ShopPageTitle";
import React, {useState} from "react";
import {CheckoutProgress} from "../shop/_components/CheckoutProgress";
import {Button, Col, Form, Row,} from "react-bootstrap";
import {Link, Navigate, useNavigate} from "react-router-dom";
import {useBasket} from "../shop/useShop";
import {OurClearAlert, SingleText, SingleTextWithClearButton} from "../_components";
import {Form as FormikForm, Formik} from "formik";
import * as yup from "yup";
import {OrderSummary} from "../shop/_components/OrderSummary";
import {usePaymentList} from "../shop/usePayment";
import {useAlert, useAuth} from "../../context";
import {PaymentMethods} from "../../utils2/maps";

export function PaymentMethod() {
    const [discountError, setDiscountError] = useState(null)
    const {basket, editArticle, errorArticle, loadingArticle, clearErrorArticle} = useBasket();
    const navigate = useNavigate()
    const {bskToken} = useAuth()


    const validationSchema = yup.object().shape({
        payment_id: yup
            .string()
            .required("Please select a payment method."),
    })


    function handleSubmit(values, actions) {
        editArticle(values)
            .then(() => navigate("/checkout/review"))
            .catch(err => {
                try {
                    setDiscountError(JSON.parse(err.message).message)
                } catch {
                    setDiscountError(null)
                }
            })
            .finally(() => actions.setSubmitting(false))
    }

    if (!bskToken || (loadingArticle === false && basket?.articles.length === 0)) {
        return <Navigate to="/shop"/>
    }

    if (basket && basket?.address_id == null) {
        return <Navigate to="/checkout/address"/>
    }

    if (basket && basket?.carrier_id == null) {
        return <Navigate to="/checkout/delivery"/>
    }

    const goBack = "/checkout/delivery"
    return (
        <>
            <CheckoutProgress/>

            <ShopPageTitle title="Payment Method"/>

            <Formik validationSchema={validationSchema} initialValues={basket} onSubmit={handleSubmit} enableReinitialize={true}>
                {({isSubmitting,setSubmitting, values, setFieldValue, errors, touched}) => (
                    <FormikForm>

                        <OurClearAlert variant="danger" msg={errorArticle} onClear={clearErrorArticle}/>
                        {/*<OurClearAlert variant="danger" msg={discountError} onClear={() => setDiscountError(null)}/>*/}
                        {discountError && (
                            <OurClearAlert
                                variant="danger"
                                msg={discountError}
                                onClear={() => {
                                    setDiscountError(null)
                                    setSubmitting(false) // explicitly re-enable submit
                                }}
                            />
                        )}

                        <Row>
                            <Col md={8}>
                                <>
                                    <PaymentList setFieldValue={setFieldValue} selectedPayment={values?.payment_id}/>
                                    {errors.payment_id && touched.payment_id && (
                                        <div className="text-danger">{errors.payment_id}</div>
                                    )}
                                </>

                                <div className="fw-semibold fs-5 mt-4 mb-2">Additional Information</div>

                                <SingleText name="note" type="textarea" label="Note" maxLength={128}/>

                                <SingleTextWithClearButton
                                    name="discount_code"
                                    label="Discount code"
                                    placeholder="Enter your code"
                                    maxLength={64}

                                />

                            </Col>

                            <Col>
                                <OrderSummary basket={basket} disabled={isSubmitting} className="d-none d-md-block"/>
                                <div className="d-flex justify-content-end">
                                    <Button as={Link} variant="link" to={goBack}>Go back</Button>
                                    <Button variant="success" type="submit" className="d-md-none" disabled={isSubmitting}>Review & Pay</Button>
                                </div>
                            </Col>
                        </Row>

                    </FormikForm>
                )}
            </Formik>
        </>
    )
}

function PaymentList({setFieldValue, selectedPayment}) {
    const {list, loadingList, errorList, clearErrorList} = usePaymentList()

    return <>
        <OurClearAlert variant="danger" msg={errorList} onClear={clearErrorList}/>

        <div>Select a payment method:</div>
        {loadingList ?
            <LoadingRadioButton/>
            :
            list && list.map(item => (
                <div key={item.id} className="d-flex flex-wrap align-items-top gap-2 my-2">
                    <Form.Check
                        className="text-capitalize"
                        type="radio"
                        // label={item.description === PaymentMethods.PayPal ? `${item.description} (+1%)` : item.description}
                        label={item.description}
                        name="payment_id"
                        id={`flexRadioDefaultPayment${item.id}`}
                        onChange={() => setFieldValue("payment_id", item.id)}
                        checked={selectedPayment === item.id}
                        disabled={!item.active}
                    />
                </div>

            ))}
    </>
}

function LoadingRadioButton() {
    return <Form.Check type="radio" label="Loading..." name="flexRadioCarrier" id="loading"/>
}
